// @ts-check
/**
 * @file routineProgress.js
 * @location src/utils/routineProgress.js
 * @role 루틴 템플릿의 「현재 발생분」 완료 집계 — 순수. 빈도별 최신 발생분(occurrenceDate ≤ today 중 최대).
 *   측정·추세 아님(razor ④/⑯) — 현재 발생분의 완료 수만. 신규 영속 필드 0.
 */

/**
 * @param {import('../data/types.js').TaskTemplate} template
 * @param {import('../data/types.js').Task[]} tasks
 * @param {string} today 'YYYY-MM-DD'
 * @returns {{ occurrenceDate: string, tasks: import('../data/types.js').Task[], done: number, total: number } | null}
 */
export function routineProgress(template, tasks, today) {
  const mine = (tasks ?? []).filter(t =>
    t.templateId === template.id && t.occurrenceDate && t.occurrenceDate <= today);
  if (mine.length === 0) return null;
  const occ = mine.reduce((max, t) => (t.occurrenceDate > max ? t.occurrenceDate : max), mine[0].occurrenceDate);
  const occTasks = mine.filter(t => t.occurrenceDate === occ && t.status !== 'cancelled');
  if (occTasks.length === 0) return null;
  const done = occTasks.filter(t => t.status === 'done').length;
  return { occurrenceDate: occ, tasks: occTasks, done, total: occTasks.length };
}
